// Review slider in the cart drawer (snippets/cart-drawer-extras.liquid). A custom element, so it
// sets itself up again each time the drawer's HTML is re-rendered.
if (!customElements.get('cart-reviews')) {
  customElements.define('cart-reviews', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-cart-reviews-track]');
      if (!track) return;
      // Keep the index ourselves: scrollLeft is mid-animation while a smooth scroll runs.
      let index = 0;
      let settle;
      const width = () => track.clientWidth + 12;
      track.addEventListener('scroll', () => {
        clearTimeout(settle);
        settle = setTimeout(() => { index = Math.round(track.scrollLeft / width()); }, 150);
      }, { passive: true });
      const step = (dir) => {
        const count = track.children.length;
        index = (index + dir + count) % count;
        clearTimeout(settle);
        track.scrollTo({ left: index * width(), behavior: 'smooth' });
      };
      this.querySelector('[data-cart-reviews-prev]')?.addEventListener('click', () => step(-1));
      this.querySelector('[data-cart-reviews-next]')?.addEventListener('click', () => step(1));
    }
  });
}

// Priority shipping toggle in the cart drawer (snippets/cart-shipping-upsell.liquid). On by
// default: added once the cart holds something else, unless the visitor turned it off this
// session; removed when it's the only thing left.
if (!customElements.get('shipping-upsell')) {
  let offInMemory = false;
  let failed = false;
  const OFF_KEY = 'cart-shipping-upsell-off';
  const isOff = () => {
    try { return offInMemory || sessionStorage.getItem(OFF_KEY) === '1'; } catch (e) { return offInMemory; }
  };
  const setOff = (off) => {
    offInMemory = off;
    try { off ? sessionStorage.setItem(OFF_KEY, '1') : sessionStorage.removeItem(OFF_KEY); } catch (e) {}
  };

  customElements.define('shipping-upsell', class extends HTMLElement {
    connectedCallback() {
      const variant = Number(this.dataset.variant);
      const line = Number(this.dataset.line);
      const others = Number(this.dataset.others);
      const toggle = this.querySelector('[data-upsell-toggle]');
      toggle?.addEventListener('change', () => {
        setOff(!toggle.checked);
        toggle.checked ? this.add(variant) : this.remove(line);
      });
      if (!others && line) this.remove(line);
      else if (others && !line && this.dataset.default === 'true' && !isOff() && !failed) this.add(variant);
    }

    add(variant) {
      this.send(window.routes.cart_add_url + '.js', { items: [{ id: variant, quantity: 1 }] });
    }

    remove(line) {
      if (line) this.send(window.routes.cart_change_url + '.js', { line: line, quantity: 0 });
    }

    send(url, body) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.routes) return;
      this.setAttribute('aria-busy', 'true');
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status || !state.sections) throw new Error(state.description || 'cart update failed');
          drawer.renderContents(state);
        })
        .catch(() => { failed = true; this.removeAttribute('aria-busy'); });
    }
  });
}
